import { render, staticRenderFns } from "./AddFlight.vue?vue&type=template&id=1ae4248c"
import script from "./AddFlight.vue?vue&type=script&lang=js"
export * from "./AddFlight.vue?vue&type=script&lang=js"
import style0 from "./AddFlight.vue?vue&type=style&index=0&id=1ae4248c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports